import { apiCall, API, NEW_BE_API } from '../../utils/APIFunctions';

export function oldGet() {
  return apiCall(`${API}/auth`, "GET");
}
export function newGet() {
  return apiCall(`${NEW_BE_API}/api/n1/users/my`, "GET");
}